import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Info } from "lucide-react";
import { useWizard } from "../../context/WizardContext";
import { CurrencyInput } from "../shared/CurrencyInput";
import type { BusinessExpenses } from "../../types/business.types";

const EXPENSE_FIELDS: { key: keyof BusinessExpenses; label: string }[] = [
  { key: "advertising", label: "Advertisement" },
  { key: "carAndTruck", label: "Car and Truck" },
  { key: "commissionsAndFees", label: "Commissions and Fees" },
  { key: "depreciation", label: "Depreciation" },
  { key: "employeeBenefits", label: "Employee Benefits" },
  { key: "insurance", label: "Insurance" },
  { key: "interestMortgage", label: "Interest (Mortgage)" },
  { key: "interestOther", label: "Interest (Other)" },
  { key: "legalAndProfessional", label: "Legal and Professional" },
  { key: "officeExpense", label: "Office Expense" },
  { key: "pensionProfitSharing", label: "Pension and Profit-Sharing" },
  { key: "rentVehicles", label: "Rent (Vehicles)" },
  { key: "rentOther", label: "Rent (Other)" },
  { key: "repairsAndMaintenance", label: "Repairs and Maintenance" },
  { key: "supplies", label: "Supplies" },
  { key: "taxesAndLicenses", label: "Taxes and Licenses" },
  { key: "utilities", label: "Utilities" },
  { key: "wages", label: "Wages" },
];

export function BusinessStep3Expenses() {
  const { businessData, updateBusinessData } = useWizard();
  const exp = businessData.expenses ?? {} as BusinessExpenses;

  const set = (patch: Partial<BusinessExpenses>) => {
    updateBusinessData({ expenses: { ...exp, ...patch } });
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-foreground">Expenses</h2>
        <p className="text-sm text-muted-foreground">
          Enter expense amounts. Leave blank any that don&apos;t apply.
        </p>
      </div>

      <Alert variant="info">
        <Info className="h-4 w-4" />
        <AlertDescription>
          Leave blank any expense that doesn&apos;t apply — they&apos;ll be treated as $0.
        </AlertDescription>
      </Alert>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Expense Line Items</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid gap-4 sm:grid-cols-2">
            {EXPENSE_FIELDS.map(({ key, label }) => (
              <CurrencyInput
                key={key}
                label={label}
                value={exp[key]}
                onChange={(v) => set({ [key]: v } as Partial<BusinessExpenses>)}
              />
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
